import urls from "../api/urls";
import {HttpServices} from "../Helpers";

// eslint-disable-next-line camelcase
export const UploadFile = async ({file, type, from_feature, for_account}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);
  formData.append("from_feature", from_feature);
  formData.append("for_account", for_account);
  const result = await HttpServices.post(urls.common.media, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "multipart/form-data",
    },
  })
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const DownloadFile = async ({file}) => {
  const result = await HttpServices.get(urls.common.download, {
    params: {file},
    responseType: "blob",
    // The request interceptor defaults every request to
    // Accept: application/json, which an endpoint that content negotiates
    // would answer with a json envelope or a 406 instead of the file bytes.
    headers: {Accept: "*/*"},
  })
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
